import React, { useState } from 'react'
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button
} from 'reactstrap'
import { API_URL } from './utils/Constants/URLS'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const UpdatePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const userDetails = useSelector(store => store.user)

  const updatePassword = async e => {
    e.preventDefault()

    // check confirm password
    if (password !== confirmPassword) {
      alert('New Password and Confirm Password should be the same')
      return
    }

    try {
      // Step 1: Verify current password
      const verifyRes = await fetch(`${API_URL}users/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: userDetails?.email,  // required for login check
          password: currentPassword   // entered current password
        })
      })
      const verifyResult = await verifyRes.json()

      if (verifyResult.error === true) {
        alert('Current password is incorrect')
        return
      }

      // Step 2: If current password is valid, update to new password
      const res = await fetch(`${API_URL}users/${userDetails?.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          password, // new password
          firstLogin: false
        })
      })

      const result = await res.json()
      if (result.error === false) {
        alert('Password updated successfully!')
        navigate('/')
        setPassword('')
        setConfirmPassword('')
        setCurrentPassword('')
      } else {
        alert(result.message || 'Something went wrong while updating password')
      }
    } catch (err) {
      console.error(err)
      alert('Something went wrong. Please try again.')
    }
  }

  return (
    <div className='p-6'>
      {/* Card */}
      <Card className='shadow rounded-2xl'>
        <CardBody>
          <h3 className='text-lg font-bold text-blue-700 mb-4'>
            Change Password
          </h3>
          <Form onSubmit={updatePassword} className='space-y-4'>
            <FormGroup>
              <Label
                for='currentPassword'
                className='text-gray-700 font-medium'
              >
                Current Password
              </Label>
              <Input
                id='currentPassword'
                name='currentPassword'
                type='password'
                placeholder='Current Password'
                value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)}
                className='bg-gray-100 rounded-md'
                required
              />
            </FormGroup>

            <FormGroup>
              <Label for='newPassword' className='text-gray-700 font-medium'>
                New Password
              </Label>
              <Input
                id='newPassword'
                name='newPassword'
                type='password'
                placeholder='New Password'
                value={password}
                onChange={e => setPassword(e.target.value)}
                className='bg-gray-100 rounded-md'
                required
              />
            </FormGroup>

            <FormGroup>
              <Label
                for='confirmPassword'
                className='text-gray-700 font-medium'
              >
                Confirm New Password
              </Label>
              <Input
                id='confirmPassword'
                name='confirmPassword'
                type='password'
                placeholder='Confirm New Password'
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                className='bg-gray-100 rounded-md'
                required
              />
            </FormGroup>

            <Button
              color='primary'
              type='submit'
              className='px-4 py-2 rounded-lg'
            >
              Update Password
            </Button>
          </Form>
        </CardBody>
      </Card>
    </div>
  )
}

export default UpdatePassword
